/**
 * Middleware to block suppliers from accessing retailer-only pages.
 * Redirects suppliers to the home page.
 * @param {object} root0
 * @param {object} root0.store
 * @param {Function} root0.redirect
 * @param {object} root0.app
 */
export default function retailerOnlyMiddleware({ store, redirect, app }) {
    const isSupplier = store.getters['global/isSupplier']

    if (isSupplier) {
        redirect(app.localePath({ name: 'home' }))
    }
}
